import React, { useEffect, useState } from "react";
import { HashRouter as Router, Routes } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalCreate, msalSignIn, msalTrigger } from "./api";
import { Button } from "acma-spa";
import { renderAppRoutes } from "./portal/appRoutes";

export interface AppProps {
  baseUrl: string;
  apiPortal: string;
  identityUrl: string;
  postLogoutUrl: string;
  b2cDomainName: string;
  b2cClientId: string;
  endSessionEndpoint: string;
}

export const App = (props: AppProps) => {
  const [msalClient, setMsalClient] = useState<PublicClientApplication>();
  const [status, setStatus] = useState<number>(-1);

  useEffect(() => {
    let msal = msalCreate(
      props.b2cDomainName,
      props.b2cClientId,
      props.endSessionEndpoint
    );
    msal
      .handleRedirectPromise()
      .then((response) => {
        setMsalClient(msal);
        let newStatus = msal.getAllAccounts().length;
        if (newStatus > 0) {
          setStatus(msal.getAllAccounts().length);
          if (response) {
            if (response.state) {
              document.location.hash = response.state;
            }
            msalTrigger();
          }
        } else {
          setStatus(newStatus);
        }
      })
      .catch((err) => {
        console.error(err);
        setStatus(0);
      });
  }, []);

  if (status < 0) {
    return (
      <>
        <div className="page-title">
          <h1>ACMA Sender ID registry</h1>
          <div className="page-title__description">
            <p>
              Please wait while we are loading ACMA Sender ID registry
              Obligations...
            </p>
          </div>
        </div>
      </>
    );
  } else if (status == 0) {
    return (
      <>
        <div className="page-title">
          <h1>ACMA Sender ID registry</h1>
          <div className="page-title__description">
            <p>Please login to continue to ACMA Sender ID registry.</p>
          </div>
        </div>
        <div>
          <div className="row">
            <div className="col">
              <Button
                label="Login now"
                onClick={() => msalSignIn(props.b2cDomainName, msalClient!)}
              />
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <Router>
        <Routes>
          {renderAppRoutes({
            baseUrl: props.baseUrl,
            msalClient: msalClient!,
            b2cDomainName: props.b2cDomainName,
            apiPortal: props.apiPortal
          })}
        </Routes>
      </Router>
    );
  }
};
